import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import HeaderFirst from 'utils/HeaderFirst';
import HeaderButton from 'utils/headerButton';
import CustomBootstrapTable from 'utils/reactTable';
import ModalClient from './Modal';
import arrow from '../../image/arrow-left.png';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './client.css';
import TablePaginators from 'components/Pagination/TablePaginator';
import useClientData from './useClientData';
import { toast } from 'react-toastify';
import { useDeleteClientMutation } from 'actions/clients/mutations';
import { GoEye } from 'react-icons/go';
import { HiCloudUpload } from "react-icons/hi";
import ModalExcel from './ModalExcel/ModalExcel';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import QueryErrorState from 'components/QueryErrorState/QueryErrorState';

import DownloadExcel from 'pagesSAGECOMPTA/FileExcel/FileExcel';
import ButtonWhite from 'components/buttons/ButtonWhite';
import TableLoader from 'components/Loader/TableLoader';
import { useDossierRole } from 'contexts/DossierRoleContext';

// Fonction pour formater la date
const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  // Format français: DD/MM/YYYY (sans heure)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
//import ModalExcel from './ModalExcel/ModalExcel';

// import axios from 'axios';
// import { useGetClientQuery } from 'actions/dossiers/queries';

const ClientPage = () => {
  const { canEdit } = useDossierRole();
  const { clientID: dossier_id } = useParams();
  const [serachTerm, setSearchedTerm] = useState('');
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const { updatedClients, handleUpdateClient, refetch, error: queryError, isLoading } = useClientData(dossier_id);
  const [deleteClient] = useDeleteClientMutation();
  const [viewArchived, setViewArchived] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalFileOpen, setIsModalFileOpen] = useState(false)


  const filteredData = updatedClients
    .filter((client) => (viewArchived ? client.archived === true : !client.archived))
    .filter((client) =>
      client?.nom?.toLowerCase().includes(serachTerm.toLowerCase())
    );

  const navigate = useNavigate();
  const data_from_ecriture_comptable = useLocation().state?.comeFrom || false

  const currentPageData = filteredData.slice(
    paginationIndex * pageSize,
    (paginationIndex + 1) * pageSize
  );

  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived); // Toggle between viewing archived and active depenses
    }
    // Handle other actions as necessary
  };

  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchedTerm(newSearchTerm);
  };

  const handleRowSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prev) => [...prev, row.id]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== row.id));
    }
  };

  const rowEvents = {
    onClick: (e, row) => {
      handleRowClick(row);
    },

  };

  const columns = [
    {
      dataField: 'compte_comptable',
      text: 'N°Compte',
      formatter: (cell) => <div>{cell}</div>,
    },
    {
      dataField: 'nom',
      text: 'Nom',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell}</div>
      ),
    },
    {
      dataField: 'created_at',
      text: "Date d'ajout",
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{formatDate(cell)}</div>
      ),
    },
    {
      dataField: 'telephone',
      text: 'Numéro de téléphone',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell}</div>
      ),
    },
    {
      dataField: 'email',
      text: 'E-mail',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell}</div>
      ),
    },
    {
      dataField: 'active',
      text: 'Statut',
      formatter: (cell) => (cell ? 'Actif' : 'Inactif'),
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: (cell, row) => (
        <GoEye
          title="Voir le détail"
          style={{ cursor: 'pointer', color: '#009688', fontSize: '18px' }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`details/${row.id}/`);
          }}
        />
      ),
    },
  ];

  const handleDossierCreated = async () => {
    // Rafraîchir les données
    await refetch();
    setIsModalOpen(false);
    // Réinitialiser le formulaire
    if (methods && methods.reset) {
      methods.reset({
        nom: '',
        telephone: '',
        adresse: '',
        email: '',
        compte_comptable: null,
      });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalFileOpen(false);
    // Réinitialiser le formulaire
    if (methods && methods.reset) {
      methods.reset({
        nom: '',
        telephone: '',
        adresse: '',
        email: '',
        compte_comptable: null,
      });
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    setIsModalFileOpen(false);
  };

  const nom = (
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">{viewArchived ? 'Clients archivés' : 'Clients'}</h4>
      <span className="nbrDossier">{filteredData?.length}</span>
    </div>
  );
  const description = <div>Voici tous vos clients {viewArchived && 'archivés'}</div>;

  const handleRowClick = () => {
    // Handle row click if needed
  };

  const onEyesClick = async () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const detailClientURL = `details/${selectedRowId}/`;
      navigate(detailClientURL);
    }
  };

  const onClickDelete = async () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins un client à supprimer.');
      return;
    }

    // Boucle directe sur la mutation : le hook toast a chaque appel,
    // on recapitule ici a la place.
    const results = await Promise.all(
      selectedRows.map((id) =>
        deleteClient({ id })
          .unwrap()
          .then(() => null)
          .catch((error) => ({ error, id }))
      )
    );
    const errors = results.filter(Boolean);
    const ok = selectedRows.length - errors.length;
    if (ok > 0) toast.success(`${ok} client(s) supprimé(s) avec succès.`);
    errors.forEach(({ error, id }) => {
      const nom = updatedClients.find((c) => c.id === id)?.nom || `#${id}`;
      toast.error(`${nom} : ${error?.data?.error || error?.data?.message || 'suppression impossible'}`);
    });
    setSelectedRows([]);
  }

  const onClickArchive = async () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins un client à archiver.');
      return;
    }

    try {
      // Déterminer le statut basé sur le premier client sélectionné
      const firstClient = updatedClients.find((c) => c.id === selectedRows[0]);
      if (!firstClient) {
        toast.error('Client non trouvé.');
        return;
      }

      // Si le client est actuellement archivé, on désarchive (active: true, archived: false)
      // Sinon on archive (active: false, archived: true)
      const shouldArchive = !firstClient.archived;
      
      // Archiver/Désarchiver tous les clients sélectionnés
      const updatePromises = selectedRows.map((id) => {
        const client = updatedClients.find((c) => c.id === id);
        if (client) {
          return handleUpdateClient(id, {
            active: !shouldArchive,    // false si on archive, true si on désarchive
            archived: shouldArchive     // true si on archive, false si on désarchive
          }).catch(error => {
            console.error(`Erreur mise à jour client ${id}:`, error);
            return { error, id };
          });
        }
        return Promise.resolve();
      });

      const results = await Promise.all(updatePromises);
      
      // Vérifier s'il y a eu des erreurs
      const errors = results.filter(r => r && r.error);
      const successes = selectedRows.length - errors.length;
      
      if (successes > 0) {
        toast.success(
          `${successes} client(s) ${shouldArchive ? 'archivé(s)' : 'désarchivé(s)'} avec succès.`
        );
      }
      
      if (errors.length > 0) {
        toast.error(`${errors.length} client(s) n'ont pas pu être mis à jour.`);
      }
      
      setSelectedRows([]); // Réinitialiser la sélection
    } catch (error) {
      toast.error(
        'Une erreur est survenue lors de la mise à jour des clients.'
      );
      console.error('Erreur lors de la mise à jour des clients :', error);
    }
  };

  const onActivedClick = async () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const client = updatedClients.find((d) => d.id === selectedRowId);
      if (!client) {
        toast.error('Client non trouvé.');
        return;
      }

      try {
        const newActiveStatus = !client.active;
        await handleUpdateClient(selectedRowId, {
          active: newActiveStatus,
          archived: !newActiveStatus, // synchroniser archived avec active
        });
        toast.info(
          `Client ${newActiveStatus ? 'activé' : 'désactivé'} avec succès.`
        );
      } catch (error) {
        toast.error(
          'Une erreur est survenue lors de la mise à jour du client.'
        );
        console.error('Erreur lors de la mise à jour du client :', error);
      }
    } else {
      toast.warning(
        'Veuillez sélectionner exactement un client à activer ou désactiver.'
      );
    }
  };

  const methods = useForm();
  return (
    <div
      className="global"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div
        className="header pb-3"
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap',
          // padding: "13px",
        }}
      >
        <HeaderFirst nom={nom} description={description} />
        {canEdit && (
          <>
            <div>
              <ButtonWhite
                text={
                  <span style={ajoutFou}><HiCloudUpload className='fs-6' /> Importer des clients</span>
                }
                onClick={() => { setIsModalFileOpen(true); setIsModalOpen(false) }} />
            </div>
            <div>
              <ButtonWhite
                text="+ Ajouter un client"
                onClick={openModal} />
            </div>
          </>
        )}
        <DownloadExcel />

        {isModalFileOpen && (
          <FormProvider {...methods}>
            <ModalExcel
              isOpen={isModalFileOpen}
              onClose={closeModal}
              refetch={refetch}
              retour={data_from_ecriture_comptable}
            >
              <h2
                style={{ color: ' #009688', fontSize: '20px', fontWeight: 700 }}
              >
                <span>
                  {' '}
                  <img src={arrow} />
                </span>{' '}
                &nbsp;IMPORTER VOS FICHIERS CLIENTS
              </h2>
            </ModalExcel>
          </FormProvider>

        )}

        {isModalOpen && (
          <ErrorBoundary>
            <FormProvider {...methods}>
              <ModalClient
                isOpen={isModalOpen}
                onClose={closeModal}
                onDossierCreated={handleDossierCreated}
                clients={updatedClients}
                retour={data_from_ecriture_comptable}
                refetch={refetch}
              >
                <h2
                  style={{ color: ' #009688', fontSize: '20px', fontWeight: 700 }}
                >
                  <span>
                    {' '}
                    <img src={arrow} />
                  </span>{' '}
                  &nbsp;CREER UN NOUVEAU DOSSIER CLIENT
                </h2>
              </ModalClient>
            </FormProvider>
          </ErrorBoundary>
        )}

      </div>
      <HeaderButton
        placeholder={'Rechercher un client'}
        onSearchChange={handleSearchChange}
        isButtonsEnabled={selectedRows.length > 0}
        onClickArchive={onClickArchive}
        onActivedClick={onActivedClick}
        onEyesClick={onEyesClick}
        onClickDelete={onClickDelete}
      />

      <div>
        {queryError ? (
          <QueryErrorState error={queryError} onRetry={refetch} title="Erreur lors du chargement des clients" />
        ) : isLoading && (!updatedClients || updatedClients.length === 0) ? (
          <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des clients..."
              subMessage="Récupération du répertoire clients et des comptes rattachés"
              minHeight="280px"
            />
          </div>
        ) : updatedClients ? (
          <CustomBootstrapTable
            keyField="id"
            data={currentPageData?.filter((client) =>
              client.nom?.toLowerCase()?.includes(serachTerm.toLowerCase())
            )}
            columns={columns}
            selectedRows={selectedRows}
            onSelectRow={handleRowSelect}
            wrapperClasses="table-wrapper"
            rowEvents={rowEvents}
          />
        ) : null}
      </div>
      {!isLoading && (!currentPageData || currentPageData.length === 0) && (
        <div className="d-flex justify-content-center fs-5 mt-4 text-muted">
          <p>Aucun client à afficher.</p>
        </div>
      )}
      {updatedClients && updatedClients.length > 0 && (
        <TablePaginators
          paginationIndex={paginationIndex}
          setPaginationIndex={handlePageChange}
          dataLength={filteredData.length}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onActionSelected={handleActionSelected}
          isViewingArchived={viewArchived}
        />
      )}
    </div>
  );
};

const ajoutFou = {
  fontFamily: 'Montserrat',
  fontWeight: '600',
  fontSize: '13px',
};
export default ClientPage;